import React from "react";

import { Container } from "react-bootstrap";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ProjectsComponent from "../components/Projects.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const Projects = () => {
  const { t } = i18n;

  return (
    <React.Fragment>
      <DocumentComponent title={t("Projects")} />
      <BannerComponent description="" title={t("Projects")} />
      <Container className="mb-5 galleryContainer">
        <ProjectsComponent />
      </Container>

      <ScheduleComponent />
    </React.Fragment>
  );
};

export default Projects;
